export class InheritanceError extends Error {
    constructor(msg?: string) {
        super(msg);
        this.name = 'InheritanceError';
    }
}
